import React from "react";

import useAuth from "../../routes/login/AuthContext";
import { ResendInvitation } from "../../services/NetworkApi";
import { Modal } from "../../components/Modal";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { useModalContext } from "../../contexts/ModalContext/context";

interface SendInvitationModalProps {
  open: boolean;
  name: string;
  invitationId: string;
  onClose: () => void;
  onSuccess: () => void;
}

export const SendInvitationModal: React.FunctionComponent<SendInvitationModalProps> = ({
  open,
  name,
  invitationId,
  onClose,
  onSuccess,
}) => {
  const { setIsOpen } = useModalContext();
  const { getAuthToken } = useAuth();

  React.useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleResendClick = React.useCallback(async () => {
    try {
      await ResendInvitation(invitationId, await getAuthToken());
      onSuccess();
    } catch (error) {
      onClose();
    }
  }, [invitationId, onSuccess, onClose]);

  return (
    <Modal
      maxWidth="sm"
      title="Resend Invitation Email"
      actions={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button appearance="primary" onClick={handleResendClick}>
            Resend
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Typography gutterBottom>
          By clicking send below, {name} will receive their invitation email again which includes their one-time use
          access link. This invitation will be sent to the email address in their user profile.
        </Typography>
        <Typography gutterBottom>
          To send to a different email address, update this in your management system and wait for the change to take
          effect in the RoomSync administrative site.
        </Typography>
      </Box>
    </Modal>
  );
};
